import { render, staticRenderFns } from "./PinCodeForm.vue?vue&type=template&id=6cb84aa8&"
import script from "./PinCodeForm.vue?vue&type=script&lang=js&"
export * from "./PinCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/juhah/Documents/Projects/faa-generator/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VSpacer,VTextField})
